@let payment = paymentMethod();
<div class="flex-1 flex-col gap-2 pl-6" [attr.data-testid]="id()">
  <div class="font-bold" [attr.data-testid]="id() | appendTestId: 'type'">
    {{ payment.type }}
  </div>
  @if (payment.sepaDirectDebit) {
    <div [attr.data-testid]="id() | appendTestId: 'sepa-iban'">
      {{ payment.sepaDirectDebit.iban }}
    </div>
    <div [attr.data-testid]="id() | appendTestId: 'sepa-bic'">
      {{ payment.sepaDirectDebit.bic }}
    </div>
    <div [attr.data-testid]="id() | appendTestId: 'sepa-direct-debit'">
      {{ payment.sepaDirectDebit.bank }}
    </div>
  }
  @if (payment.payPal) {
    <div [attr.data-testid]="id() | appendTestId: 'paypal-display-name'">
      {{ payment.displayName }}
    </div>
    <div [attr.data-testid]="id() | appendTestId: 'paypal-e-mail'">
      {{ payment.payPal.payerEmail }}
    </div>
  }
  @if (payment.creditCard) {
    <div [attr.data-testid]="id() | appendTestId: 'credit-card-display-name'">
      {{ payment.displayName }}
    </div>
    <div [attr.data-testid]="id() | appendTestId: 'credit-card-expiry-date'">
      {{ payment.creditCard.expiryDate }}
    </div>
  }
  @if (payment.amazon) {
    <div [attr.data-testid]="id() | appendTestId: 'amazon-display-name'">
      {{ payment.displayName }}
    </div>
    <div [attr.data-testid]="id() | appendTestId: 'amazon-payer-name'">
      {{ payment.amazon.payerName }}
    </div>
    <div [attr.data-testid]="id() | appendTestId: 'amazon-e-mail'">
      {{ payment.amazon.payerEmail }}
    </div>
  }
</div>
